// extracted by mini-css-extract-plugin
export var gasProduct = "style-module--gasProduct--b6037";
export var gasProductIconWrapper = "style-module--gasProductIconWrapper--c24a4";